import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-selected-file-icon',
  templateUrl: './files-selected-file.component.html'
})
export class FilesSelectedFileComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
